import { allOfclSTypes, baseSTypes, levels } from "../configs";
import { artMS } from "../data/artifacts/config";
import { findArtifact, findCharacter, findWeapon } from "../data/controllers";
import { wpMainStatAtLv, wpSubStatAtLv } from "../data/weapons/config";
import { addOrInit, applyPct, toMult } from "../helpers";
import { pushOrMerge } from "./helpers";

export function initiateATTRs(char, wpData, weapon, tracker) {
  const ATTRs = {};
  for (const type of allOfclSTypes) {
    ATTRs[type] = 0;
  }
  const charData = findCharacter(char, "stats");
  const stats = { ...charData.stats[levels.indexOf(char.level)] };
  addOrInit(stats, "CRIT Rate", 5);
  addOrInit(stats, "CRIT DMG", 50);
  addOrInit(stats, "Energy Recharge", 100);
  stats["Normal ATK SPD"] = stats["Charged ATK SPD"] = 100;
  for (const key in stats) {
    addOrInit(ATTRs, key, stats[key]);
    if (tracker) {
      const field = key.slice(0, 4) === "Base" ? key.slice(5) : key;
      tracker[field].push({ desc: "Character Base stat", value: stats[key] });
    }
  }
  const wpAtk = wpMainStatAtLv(wpData.mainStatScale, weapon.level);
  ATTRs["Base ATK"] += wpAtk;
  if (tracker) {
    tracker.ATK.push({ desc: "Weapon Main stat", value: wpAtk });
  }
  return ATTRs;
}

export function addArtStats(pieces, ATTRs, tracker) {
  const artSBnes = { HP: 0, ATK: 0, DEF: 0 };
  for (const artP of pieces) {
    if (artP) {
      const { type, level, rarity = 5, mainSType, subS } = artP;
      const mainStat = artMS[type][mainSType][rarity][level];
      addOrInit(artSBnes, mainSType, mainStat);
      if (tracker) {
        tracker[mainSType].push({
          desc: type[0].toUpperCase() + type.slice(1),
          value: mainStat
        });
      }
      for (const ss of subS) {
        addOrInit(artSBnes, ss.type, +ss.val);
        pushOrMerge(tracker, ss.type, "Artifact Sub-stat", +ss.val);
      }
    }
  }
  for (const type of baseSTypes) {
    const pctStats = artSBnes[`${type}%`];
    if (pctStats) {
      artSBnes[type] += applyPct(ATTRs[`Base ${type}`], pctStats);
    }
    delete artSBnes[`${type}%`];
  }
  for (const type in artSBnes) {
    ATTRs[type] += artSBnes[type];
  }
  return artSBnes;
}

export function addWpSubStat(wpData, ATTRs, wpLevel, tracker) {
  if (!wpData.subStat) return; // 1* 2* have no sub
  const { type, scale } = wpData.subStat;
  const value = wpSubStatAtLv(scale, wpLevel);
  ATTRs[type] += value;
  if (tracker) {
    tracker[type].push({ desc: `${wpData.name} Sub-stat`, value });
  }
}

export function addArtBonuses(isFinal, sets, wrapper) {
  for (const { code, bonusLv } of sets) {
    for (let i = 0; i <= bonusLv; i++) {
      const { name, setBnes } = findArtifact({ code });
      const { addBnes, addFinalBnes } = setBnes[i];
      const tkDesc = `${name} / ${(i + 1) * 2}-Piece Set bonus`;
      if (!isFinal && addBnes) {
        addBnes({ ...wrapper, tkDesc });
      } else if (isFinal && addFinalBnes) {
        addFinalBnes({ ...wrapper, tkDesc });
      }
    }
  }
}

export function addWpBonuses(isFinal, wpData, wpRfm, wrapper, partyData) {
  const { addBnes, addFinalBnes } = wpData;
  const tkDesc = `${wpData.name} bonus`;
  if (!isFinal && addBnes) {
    addBnes({ ...wrapper, wpRfm, partyData, tkDesc });
  } else if (isFinal && addFinalBnes) {
    addFinalBnes({ ...wrapper, wpRfm, tkDesc });
  }
}

export function calcFinalATTRs(ATTRs) {
  baseSTypes.forEach((type) => {
    ATTRs[type] += Math.round(
      ATTRs[`Base ${type}`] * toMult(ATTRs[`${type}%`])
    );
    delete ATTRs[`${type}%`];
  });
}

export default function getBaseStats(charData, char, weapon, art) {
  if (!weapon) return [{}, {}];
  const wpData = findWeapon(weapon);
  const ATTRs = initiateATTRs(char, wpData, weapon);
  const artSBnes = addArtStats(art.pieces, ATTRs);
  addWpSubStat(wpData, ATTRs, weapon.level);

  const wrapper = { ATTRs, charData };
  addArtBonuses(false, art.sets, wrapper);
  addWpBonuses(false, wpData, weapon.refinement, wrapper);
  calcFinalATTRs(ATTRs);
  return [ATTRs, artSBnes];
}
